import React, { useContext, useState, useEffect } from "react";
import { DContext } from "../../../context/Datacontext";
import { FiPlus, FiTrash2 } from "react-icons/fi";
import { useNavigate } from "react-router-dom";

export const Education = () => {
    const { BeURL, instructor, setInstructor , showAlert} = useContext(DContext);

    const navigate = useNavigate()

    const [education, setEducation] = useState([
        { degree: "", institute: "", year: "", field: "" },
    ]);

    const [loading, setLoading] = useState(false);

    // Load existing education
    useEffect(() => {
        if (instructor?.education?.length > 0) {
            setEducation(instructor.education);
        }
    }, [instructor]);

    const addEducation = () => {
        setEducation([
            ...education,
            { degree: "", institute: "", year: "", field: "" },
        ]);
    };

    const removeEducation = (index) => {
        const updated = [...education];
        updated.splice(index, 1);

        if (updated.length === 0) {
            updated.push({
                degree: "",
                institute: "",
                year: "",
                field: "",
            });
        }

        setEducation(updated);
    };

    const handleChange = (index, e) => {
        const updated = [...education];
        updated[index][e.target.name] = e.target.value;
        setEducation(updated);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            setLoading(true);

            const res = await fetch(
                `${BeURL}/update/instructor/profile/education`,
                {
                    method: "PUT",
                    credentials: "include",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ education }),
                }
            );

            if (!res.ok) throw new Error("Server error");

            const data = await res.json();

            if (data.success) {
                showAlert("Education created Successfully");
                navigate('/instructor/my/social-links')
                setInstructor(data.updatedInstructor);
            } else {
                showAlert(data.message);
            }

        } catch (err) {
            console.error("Error on create Education", err);
            showAlert("Something went wrong");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="max-w-5xl bg-white p-6 rounded-xl shadow-sm">
            <div className="flex justify-between items-center mb-6">
                <h2 className="text-xl font-semibold">Education</h2>

                <button
                    type="button"
                    onClick={addEducation}
                    className="flex items-center gap-2 text-primary-600 font-semibold"
                >
                    <FiPlus /> Add Education
                </button>
            </div>

            <form onSubmit={handleSubmit} className="space-y-6">
                {education.map((edu, index) => (
                    <div
                        key={index}
                        className="border rounded-xl p-5 bg-gray-50 space-y-4"
                    >
                        <div className="grid sm:grid-cols-2 gap-4">
                            <input
                                name="degree"
                                placeholder="Degree (MCA, B.E)"
                                value={edu.degree}
                                onChange={(e) => handleChange(index, e)}
                                className="border px-3 py-2 rounded-lg"
                            />

                            <input
                                name="field"
                                placeholder="Field (Computer Science)"
                                value={edu.field}
                                onChange={(e) => handleChange(index, e)}
                                className="border px-3 py-2 rounded-lg"
                            />

                            <input
                                name="institute"
                                placeholder="Institute / University"
                                value={edu.institute}
                                onChange={(e) => handleChange(index, e)}
                                className="border px-3 py-2 rounded-lg"
                            />

                            <input
                                type="number"
                                name="year"
                                placeholder="Year (2025)"
                                value={edu.year}
                                onChange={(e) => handleChange(index, e)}
                                className="border px-3 py-2 rounded-lg"
                            />
                        </div>

                        {education.length > 1 && (
                           <div className="flex justify-end">
                                <button
                                    type="button"
                                    onClick={() => removeEducation(index)}
                                    className="flex items-center gap-2 text-red-500 text-sm"
                                >
                                    <FiTrash2 /> Remove
                                </button>
                           </div>
                        )}
                    </div>
                ))}

                <div className="flex justify-end">
                    <button
                        type="submit"
                        disabled={loading}
                        className="bg-primary-600 text-white px-6 py-2 rounded-lg"
                    >
                        {loading ? "Saving..." : "Save"}
                    </button>
                </div>


            </form>
        </div>
    );
};
